import * as GoogleMapsLoader from 'google-maps';
var GoogleMapsService = /** @class */ (function () {
    function GoogleMapsService() {
        GoogleMapsLoader.KEY = 'AIzaSyCmilnnhDHsQVOq3GhGgwwxoXXi1uQ_GfY';
        this.promise = new Promise(function (res) { GoogleMapsLoader.load(res); });
    }
    return GoogleMapsService;
}());
export { GoogleMapsService };
//# sourceMappingURL=google-maps.service.js.map